import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import $ from "jquery";
import logo from "../../../../src/assets/admin/img/logos/astro-adi-logo1.png";
import { useTranslation } from "react-i18next";
import * as dashboardServices from "../services/dashboard.services"; // Import services
import { SOCKET_CLIENT } from "../../../utils/socket";

const SideBar = () => {
  const loc = useLocation();
  const { t } = useTranslation();
  const [badges, setBadges] = useState({
    return_requests: 0,
    pending_pujas: 0,
    pending_withdrawals: 0,
    unread_chats: 0,
  });

  const fetchBadges = () => {
    dashboardServices
      .getSidebarBadges()
      .then((res) => {
        if (res.data) {
          setBadges(res.data);
        }
      })
      .catch(console.error);
  };

  useEffect(() => {
    fetchBadges();

    const handleNewMessageNotification = () => {
      fetchBadges();
    };

    SOCKET_CLIENT.on("NEW-MESSAGE-NOTIFICATION", handleNewMessageNotification);
    SOCKET_CLIENT.on("NEW-MESSAGE", handleNewMessageNotification);

    return () => {
      SOCKET_CLIENT.off("NEW-MESSAGE-NOTIFICATION", handleNewMessageNotification);
      SOCKET_CLIENT.off("NEW-MESSAGE", handleNewMessageNotification);
    };
  }, [loc.pathname]); // Refresh on route change

  const toggleDropdown = (e) => {
    e.preventDefault();
    const dropDown = e.target.parentElement;
    if (dropDown.classList.contains("show")) {
      dropDown.classList.remove("show");
    } else {
      dropDown.classList.add("show");
    }
  };

  const hoverSidebar = (e) => {
    if ($("body").hasClass("main-sidebar-hide")) {
      $("body").addClass("main-sidebar-open");
    } else {
      $("body").removeClass("main-sidebar-open");
    }
  };

  const removeHoverSidebar = (e) => {
    $("body").removeClass("main-sidebar-open");
  };

  return (
    <div
      className="main-sidebar main-sidebar-sticky side-menu ps ps--active-y"
      id="app_sidebar"
      onMouseEnter={hoverSidebar}
      onMouseLeave={removeHoverSidebar}
    >
      <div className="sidemenu-logo">
        <a className="main-logo" href="/admin/dashboard">
          <img
            src={logo}
            className="header-brand-img icon-logo admin-logo"
            alt="logo"
            style={{ height: "1.6rem" }}
            id="logo_short"
          />
          <img
            src={logo}
            className="header-brand-img desktop-logo admin-logo rounded"
            style={{ height: "2.3rem" }}
            alt="logo"
            id="logo_full"
          />
        </a>
      </div>
      {/* Dashboard section start */}
      <div className="main-sidebar-body">
        <ul className="nav">
          {/* ... existing items ... */}
          <li
            className={
              "nav-item" +
              (loc.pathname === "/admin/dashboard" ? " active" : "")
            }
          >
            <Link className="nav-link" to="/admin/dashboard">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-home sidemenu-icon"></i>
              <span className="sidemenu-label">
                {t("sidebar_link_dashboard")}
              </span>
            </Link>
          </li>
          {/* Dashboard section end */}

          {/* Revenue Dashboard section start */}
          <li
            className={
              "nav-item" + (loc.pathname === "/admin/revenue" ? " active" : "")
            }
          >
            <Link className="nav-link" to="/admin/revenue">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-chart-line sidemenu-icon"></i>
              <span className="sidemenu-label">Revenue Report</span>
            </Link>
          </li>
          {/* Revenue Dashboard section end */}

          {/* Analytics Reports section start */}
          <li
            className={
              "nav-item" +
              (loc.pathname === "/admin/analytics-reports" ? " active" : "")
            }
          >
            <Link className="nav-link" to="/admin/analytics-reports">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-chart-bar sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Analytics Reports")}</span>
            </Link>
          </li>
          {/* Analytics Reports section end */}

          {/* Live Consultation Monitor section start */}
          <li
            className={
              "nav-item" +
              (loc.pathname === "/admin/live-consultation-monitor"
                ? " active"
                : "")
            }
          >
            <Link className="nav-link" to="/admin/live-consultation-monitor">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-video sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Live Consultation")}</span>
            </Link>
          </li>

          {/* User section start */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/admin/user-management")
                ? "show active"
                : "")
            }
          >
            <Link className="nav-link" to="/admin/user-management/user/list/1">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-user-tie sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Users")}</span>
            </Link>
          </li>

          {/* user section end */}

          {/* astrologer section start */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/admin/astrologer-management")
                ? "show active"
                : "")
            }
          >
            <Link
              className="nav-link"
              to="/admin/astrologer-management/astrologer/list/1"
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-user-astronaut sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Astrologers")}</span>
            </Link>
          </li>
          {/* astrologer section end */}

          {/* astrologer consultations section start */}
          <li
            className={
              "nav-item " +
              (loc.pathname.includes("/admin/consultation")
                ? "show active"
                : "")
            }
          >
            <Link className="nav-link" to="/admin/consultation/list/1">
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-calendar-check sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Consultations")}</span>
            </Link>
          </li>
          {/* astrologer consultations section end */}

          {/* Transaction section start */}

          {/* <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/payable-transaction") || loc.pathname.includes("/payout-transaction")
                ? "show active"
                : "")
            }
          >
            <a
              className="nav-link with-sub submenu"
              onClick={toggleDropdown}
              href={"/"}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-money-bill-wave sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Transaction")}</span>
              <i className="angle fe fe-chevron-right"></i>
            </a>
            <ul className="nav-sub">
              <li
                className={`nav-sub-item ${loc.pathname.includes("/payable-transaction") ? "active" : ""
                  }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/payable-transaction/list/1`}
                >
                  Payable transaction
                </Link>
              </li>
              <li
                className={`nav-sub-item ${loc.pathname.includes("/payout-transaction") ? "active" : ""
                  }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/payout-transaction/list/1`}
                >
                  Payout Transaction
                </Link>
              </li>
            </ul>
          </li> */}

          {/* Transaction section end */}

          {/* Cms section start */}
          {/* {hasPermission("/admin/cms") ? ( */}
          <li
            className={
              `nav-item ` + (loc.pathname.includes("/cms") ? "show active" : "")
            }
          >
            <a
              className="nav-link with-sub submenu"
              onClick={toggleDropdown}
              href={"/"}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-edit sidemenu-icon"></i>
              <span className="sidemenu-label">{t("sidebar_link_cms")}</span>
              <i className="angle fe fe-chevron-right"></i>
            </a>
            <ul className="nav-sub">
              <li
                className={`nav-sub-item ${
                  loc.pathname.includes("/cms/pages") ? " active" : ""
                }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/cms/pages/list/${1}`}
                >
                  {t("sidebar_link_pages")}
                </Link>
              </li>
              <li
                className={`nav-sub-item ${
                  loc.pathname.includes("/cms/service-offer") ? " active" : ""
                }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/cms/service-offer/add`}
                >
                  {t("Service Offers")}
                </Link>
              </li>
              <li
                className={`nav-sub-item ${
                  loc.pathname.includes("/cms/learn-hub") ? " active" : ""
                }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/cms/learn-hub/list/${1}`}
                >
                  Learn Hub
                </Link>
              </li>
              <li
                className={`nav-sub-item ${
                  loc.pathname.includes("/cms/faq") ? " active" : ""
                }`}
              >
                <Link className="nav-sub-link" to={`/admin/cms/faq/list/${1}`}>
                  FAQ
                </Link>
              </li>
              <li
                className={`nav-sub-item ${
                  loc.pathname.includes("/cms/services") ? " active" : ""
                }`}
              >
                <Link className="nav-sub-link" to={`/admin/cms/services/list/1`}>
                  Services
                </Link>
              </li>
              <li
                className={`nav-sub-item ${
                  loc.pathname.includes("/cms/languages") ? " active" : ""
                }`}
              >
                <Link className="nav-sub-link" to={`/admin/cms/languages/list/1`}>
                  Languages
                </Link>
              </li>
              <li
                className={
                  "nav-sub-item" +
                  (loc.pathname.includes("/cms/default-email-template")
                    ? " active"
                    : "")
                }
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/cms/default-email-template/list/${1}`}
                >
                  {t("sidebar_link_email_template")}
                </Link>
              </li>

              {/* email-announcement */}
              <li
                className={
                  "nav-sub-item" +
                  (loc.pathname.includes("/cms/email-announcement")
                    ? " active"
                    : "")
                }
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/cms/email-announcement`}
                >
                  {t("Email Announcement")}
                </Link>
              </li>

              {/* notification-announcement */}
              <li
                className={
                  "nav-sub-item" +
                  (loc.pathname.includes("/cms/notification-announcement")
                    ? " active"
                    : "")
                }
              >
                <Link
                  className="nav-sub-link"
                  to={`/admin/cms/notification-announcement`}
                >
                  {t("Notification Announcement")}
                </Link>
              </li>

              {/* <li
                className={
                  "nav-sub-item" +
                  (loc.pathname.includes("/cms/web-home") ? " active" : "")
                }
              >
                <Link className="nav-sub-link" to={`/admin/cms/web-home`}>
                  {t("Website Home")}
                </Link>
              </li> */}

              {/* <li
                className={
                  "nav-sub-item" +
                  (loc.pathname.includes("/cms/about-us") ? " active" : "")
                }
              >
                <Link className="nav-sub-link" to={`/admin/cms/about-us`}>
                  {t("About Us")}
                </Link>
              </li> */}

              <li
                className={
                  "nav-sub-item" +
                  (loc.pathname.includes("/cms/settings") ? " active" : "")
                }
              >
                <Link className="nav-sub-link" to={`/admin/cms/settings`}>
                  {t("sidebar_link_global_settings")}
                </Link>
              </li>
            </ul>
          </li>
          {/* // ) : null} */}
          {/* Cms section end */}

          {/* subscription section start */}

          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/subscription") ? "show active" : "")
            }
          >
            <a
              className="nav-link with-sub submenu"
              onClick={toggleDropdown}
              href={"/"}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fa fa-credit-card sidemenu-icon"></i>
              <span className="sidemenu-label">
                {t("sidebar_link_subscription")}
              </span>
              <i className="angle fe fe-chevron-right"></i>
            </a>
            <ul className="nav-sub">
              <li
                className={`nav-sub-item ${
                  loc.pathname.includes("/subscription/subscription-feature")
                    ? " active"
                    : ""
                }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`subscription/subscription-feature`}
                >
                  Subscription Features
                </Link>
              </li>
              {/* <li
                className={`nav-sub-item ${loc.pathname.includes("/subscription/subscription-benefit") ? " active" : ""
                  }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`subscription/subscription-benefit`}
                >
                  Subscription Benefits
                </Link>
              </li> */}
              <li
                className={`nav-sub-item ${
                  loc.pathname.includes("/subscription/subscription-plan")
                    ? " active"
                    : ""
                }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`subscription/subscription-plan/list/1`}
                >
                  Subscription Plan
                </Link>
              </li>
              {/* <li
                className={`nav-sub-item ${loc.pathname.includes("/subscription/transaction") ? " active" : ""
                  }`}
              >
                <Link
                  className="nav-sub-link"
                  to={`subscription/transaction/list/1`}
                >
                  Transaction
                </Link>
              </li> */}
            </ul>
          </li>

          {/* subscription section end */}

          {/* testimonial management section end */}
          {/* <li
              className={
                `nav-item ` +
                (loc.pathname.includes("/testimonial-management")
                  ? "show active"
                  : "")
              }
            >
              <Link
                className="nav-link"
                to={`/admin/testimonial-management/testimonial/list/${1}`}
              >
                <span className="shape1"></span>
                <span className="shape2"></span>
                <i className="fa fa-comment-dots sidemenu-icon"></i>
                <span className="sidemenu-label">
                {t("sidebar_link_testimonials")}
                </span>
              </Link>
            </li> */}
          {/* testimonial management section end */}

          {/* <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/inquiry")
                ? "show active"
                : "")
            }
          >
            <Link
              className="nav-link"
              to={`/admin/inquiry/list/${1}`}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-question-circle sidemenu-icon"></i>
              <span className="sidemenu-label">
                {t("Advisor Inquiry")}
              </span>
            </Link>
          </li> */}

          {/*  Contact Us section  */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/contact-us")
                ? "show active"
                : "")
            }
          >
            <Link
              className="nav-link"
              to={`/admin/contact-us/list/${1}`}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-address-card sidemenu-icon"></i>
              <span className="sidemenu-label">
                {t("sidebar_link_contact_us")}
              </span>
            </Link>
          </li>
          {/*  Contact Us section end */}

          {/* Remedies sart  */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/remedies-management")
                ? "show active"
                : "")
            }
          >
            <Link
              className="nav-link"
              to={`/admin/remedies-management/remedies/list/1`}
            >
              <span className="shape1"></span>
              <span className="shape2"></span>
              {/* <i className="fas fa-praying-hands sidemenu-icon"></i> */}
              <i className="fas fa-gem sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Remedies")}</span>
            </Link>
          </li>
          {/* Remedies end */}

          {/* Withdrawal start */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/withdrawal") ? "show active" : "")
            }
          >
            <Link className="nav-link" to={`/admin/withdrawal/list/1`}>
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-wallet sidemenu-icon"></i>
              <span className="sidemenu-label">
                {t("Withdrawals")}
                {badges.pending_withdrawals > 0 && (
                  <span className="badge bg-info ms-2">
                    {badges.pending_withdrawals}
                  </span>
                )}
              </span>
            </Link>
          </li>
          {/* Withdrawal end */}

          {/* Order start */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/order") ? "show active" : "")
            }
          >
            <Link className="nav-link" to={`/admin/order/list/1`}>
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-shopping-basket sidemenu-icon"></i>
              <span className="sidemenu-label">
                {t("Orders")}
                {badges.return_requests > 0 && (
                  <span className="badge bg-danger ms-2">
                    {badges.return_requests}
                  </span>
                )}
              </span>
            </Link>
          </li>
          {/* Order end */}

          {/* Puja Booking start */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/puja-booking") ? "show active" : "")
            }
          >
            <Link className="nav-link" to={`/admin/puja-booking/list/1`}>
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-pray sidemenu-icon"></i>
              <span className="sidemenu-label">
                {t("Puja Bookings")}
                {badges.pending_pujas > 0 && (
                  <span className="badge bg-warning ms-2">
                    {badges.pending_pujas}
                  </span>
                )}
              </span>
            </Link>
          </li>
          {/* Puja Booking end */}

          {/* Feedback start */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/feedback") ? "show active" : "")
            }
          >
            <Link className="nav-link" to={`/admin/feedback/list/1`}>
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-comment-dots sidemenu-icon"></i>
              <span className="sidemenu-label">{t("Feedback")}</span>
            </Link>
          </li>
          {/* Feedback end */}

          {/*  Chat Support section start  */}
          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/chat-support") ? "show active" : "")
            }
          >
            <Link className="nav-link" to={`/admin/chat-support`}>
              <span className="shape1"></span>
              <span className="shape2"></span>
              <i className="fas fa-comments sidemenu-icon"></i>
              <span className="sidemenu-label">
                {t("Chat Support")}
                {badges.unread_chats > 0 && !loc.pathname.includes("/chat-support") && (
                  <span className="badge bg-danger ms-2">
                    {badges.unread_chats}
                  </span>
                )}
              </span>
            </Link>
          </li>
          {/*  Chat Support section end */}
        </ul>
      </div>
    </div>
  );
};

export default SideBar;
